import React from 'react';
import Button from '../../../../../../../../components/form/button/button';
const EditableTable = ({headers, data,tableHeading,actionButtons=[]}) => {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:"1rem",overflow:"auto"}}>
{  (tableHeading || actionButtons?.length>0 )&&     <div style={{display: 'flex', justifyContent: 'space-between'}}>
                      {/* <p style={{fontSize: '18px'}}>{tableHeading}</p> */}
                      {tableHeading}
                      {actionButtons?.map((item,index)=>(
                        <Button
                        key={index}
                        clickHandler={item?.clickHandler}
                        variant={'submit-button'}
                        styles={{maxWidth:"200px"}}
                        >
                        {item?.text}
                      </Button>
                      ))}
      
             
                    </div>}
      <table id="editableTable">
        <thead>
          <tr>
            {headers?.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index}>
              {item.map((value, rowIndex) => (
                <td key={rowIndex}> {value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EditableTable;
